import { OnWidgetDrilldown } from '../../types';
import { PieChartClickHandler } from './EChart';
import { ArdoqId, WidgetTypes } from '@ardoq/api-types';
import { CategoricalDrilldownData, PieChartRenderData } from '../renderTypes';
import { PieChartWidgetProps } from './PieChartWidget';
import { Locale } from '@ardoq/locale';
import { getWidgetDrilldownFilters } from '../getWidgetDrilldownFilters';
import { WidgetLinkedDashboardFilter } from '../types';
import type { I18nLocale } from '@ardoq/i18n';

type GetPieChartPropsParam = {
  widgetRenderData: PieChartRenderData;
  widgetDrilldownData: CategoricalDrilldownData;
  onWidgetDrilldown?: OnWidgetDrilldown;
  colors: Record<string, string>;
  userLocale: Locale;
  activeLinkedDashboardFilters?: WidgetLinkedDashboardFilter[];
  dashboardId?: ArdoqId;
  i18nLocale: I18nLocale;
};

export const getPieChartProps = ({
  widgetRenderData,
  widgetDrilldownData,
  onWidgetDrilldown,
  activeLinkedDashboardFilters,
  dashboardId,
  ...props
}: GetPieChartPropsParam): PieChartWidgetProps & {
  viewType: WidgetTypes.PIE_CHART;
} => {
  const getClickHandler = onWidgetDrilldown
    ? (otherDataSegments: Array<{ name: string }>): PieChartClickHandler =>
        ({ data }) => {
          const filters = getWidgetDrilldownFilters({
            widgetRenderData: widgetRenderData.data,
            widgetDrilldownData,
            otherDataSegments,
            dataName: data.name,
            isOtherSegment: data.isOtherSegment,
            activeLinkedDashboardFilters,
          });

          onWidgetDrilldown({
            datasource: widgetDrilldownData.datasource,
            filters,
            widgetType: WidgetTypes.PIE_CHART,
            dashboardId,
          });
        }
    : undefined;
  return {
    ...props,
    ...widgetRenderData,
    numberFormatOptions: widgetRenderData.numberFormatOptions ?? undefined,
    isAbbreviated: widgetRenderData.isAbbreviated,
    getClickHandler,
  };
};
